import { Backdrop, CircularProgress, Stack } from "@mui/material";
import LoaderInnerConetnt from "./LoaderInnerConetnt";

/**
 * 전체 화면 오버레이 로딩 — Backdrop + 큰 CircularProgress + 설명 텍스트.
 *
 * 인라인 로딩이 필요하면 `SmallLoadingIndicator` 를 쓴다.
 *
 * @remarks
 * 디렉토리명에 오타가 있다 (`BigLoaingIndicator` — i 누락). barrel(`@/domains/shared/components`)을 통해 import 하면 영향 없음.
 */
interface BigLoadingIndicatorProps {
  /** 로딩 중 표시할 설명 텍스트 */
  description: string;
}

const BigLoadingIndicator = ({ description }: BigLoadingIndicatorProps) => {
  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: 2000,
        color: "#fff",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={60} thickness={4} />
        <LoaderInnerConetnt description={description} />
      </Stack>
    </Backdrop>
  );
};

export default BigLoadingIndicator;
